import { render, staticRenderFns } from "./AMSProductSelector.vue?vue&type=template&id=9b591406&scoped=true&"
import script from "./AMSProductSelector.vue?vue&type=script&lang=ts&"
export * from "./AMSProductSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AMSProductSelector.vue?vue&type=style&index=0&id=9b591406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b591406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCheckbox,VDataTable,VFlex,VForm,VIcon,VLayout,VTextField})
